export const getSortedStudyFields = (data: any): string[] => {
  return Object.keys(data.studyFields).sort((a, b) => a.localeCompare(b));
};

export const getSortedProgramLevels = (data: any): string[] => {
  const allLevels: string[] = [];
  Object.values(data.programLevels).forEach((category: any) => {
    Object.values(category).forEach((levels: any) => {
      allLevels.push(...levels);
    });
  });
  return allLevels.sort((a, b) => a.localeCompare(b));
};

export const getSortedDestinations = (data: any): string[] => {
  const allDestinations: string[] = [];
  Object.values(data.destination).forEach((region: any) => {
    Object.values(region).forEach((subRegion: any) => {
      allDestinations.push(...subRegion);
    });
  });
  return allDestinations.sort((a, b) => a.localeCompare(b));
};
